import { render } from "./DjiInBoundOrderCheckIn.vue?vue&type=template&id=bc40fba0&scoped=true"
import script from "./DjiInBoundOrderCheckIn.vue?vue&type=script&lang=js"
export * from "./DjiInBoundOrderCheckIn.vue?vue&type=script&lang=js"

import "./DjiInBoundOrderCheckIn.vue?vue&type=style&index=0&id=bc40fba0&scoped=true&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc40fba0"]])

export default __exports__